import { CloseReadingConstants } from '@mission.io/question-toolkit'
export const CLOSE_READING: CloseReadingConstants = {
	MATCH_TYPE: {
		WORD: 'WORD',
	},
	GRADING: {
		PASS_FAIL: 'PASS_FAIL',
		NONE: 'NONE',
		PARTIAL_CREDIT: 'PARTIAL_CREDIT',
	},
	ANNOTATION_TOOL: {
		HIGHLIGHT: 'HIGHLIGHT',
		UNDERLINE: 'UNDERLINE',
		STRIKE_THROUGH: 'STRIKE_THROUGH',
	},
	COLOR: {
		BLUE: 'BLUE',
		GREEN: 'GREEN',
		YELLOW: 'YELLOW',
		PURPLE: 'PURPLE',
		ORANGE: 'ORANGE',
		PINK: 'PINK',
		BLACK: 'BLACK',
	},
}
